import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const FormWrapper = ({ children, className }) => (
  <div className={cn('row', className)}>
    {children}
  </div>
);

FormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

FormWrapper.defaultProps = {
  className: '',
};

export default FormWrapper;
